import React from 'react';
import { Button, Divider } from 'antd';

/**
 * ResumeSection: 节段容器
 * - 顶部标题栏只对 single 类型渲染"编辑"入口;
 *   list 类型的"添加"入口由各 section 模块(ListSectionView / IntentionsView)底部独占,
 *   头部不再重复,保持页面简洁。
 */
const ResumeSection = ({ section, editing, adding, onEdit, children }) => {
  const showTopAction = !editing && !adding && section.type === 'single' && typeof onEdit === 'function';

  return (
    <section className="resume-new-section" id={section.id}>
      <div className="resume-new-section-header">
        <div className="resume-new-section-title-wrap">
          <span className="resume-new-section-title">{section.title}</span>
          {section.tips ? <span className="resume-new-section-tips">{section.tips}</span> : null}
        </div>
        {showTopAction ? (
          <Button type="link" className="resume-new-section-action" onClick={onEdit}>编辑</Button>
        ) : null}
      </div>
      <Divider className="resume-new-section-divider" />
      <div className="resume-new-section-body">{children}</div>
    </section>
  );
};

export default ResumeSection;